module.exports = ".switch {\n    margin-bottom: 10px;\n}\n.location_domain_edit.edit-location {\n    display: none;\n}\n.edit_domain {\n    cursor: pointer;\n}"